import React, { useState, useContext, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import {
  Card,
  CardBody,
  Row,
  Col,
  CustomInput,
  FormGroup,
  Button,
} from 'reactstrap';
import cogoToast from 'cogo-toast';
import MainTable from '../../../components/tables/MainTable';
import DetailRow from '../../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import { InfoMovesContext } from '../InfoMovesContext';
import { refFormat } from '../../../helpers/tableFormatters';
import { currencyFormat } from '../../../helpers/tableFormatters';
import { formatDate } from '../../../helpers/dateFormatters';
import ExampleCustomInput from '../../../components/input/ExampleCustomInput'
import WizardInput from '../../../components/auth/wizard/WizardInput';
import { EnvironmentContext } from '../../../context/Context';
import { informesServices } from '../../../services';
import ExcelExport from '../../../components/excel/ExcelExport';
import PdfExport from '../../../components/pdf/table/export/PdfExport';
import ButtonIcon from '../../../components/common/ButtonIcon';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { authSesion } from "../../../helpers/authSesion";
import { urlApi } from '../../../configuracion/serverConfig';

export const dateConceptFormatter = (dataField, fieldSelected) => {
  if (!fieldSelected) return <></>
  return (
    <div>
      <div className='font-weight-bold'>{fieldSelected.fecha}</div>
      <div>{fieldSelected.nombreConcepto}</div>
    </div>
  )
}

export const clientFormatter = (dataField, fieldSelected) => {
  if (!fieldSelected) return <></>
  return (
    <div>
      <div className='text-primary'>{fieldSelected.nombreTercero}</div>
      <div>{fieldSelected.identificacionTercero}</div>
    </div>
  )
}

export const linkStyles = {
  "textDecoration": "none",
  "color": "#000",
  "position": "absolute",
  "top": 0,
  "bottom": 0,
  "left": 0,
  "right": 0,
  "display": "none",
}

/*export const headers = [
  { label: "No. DE INGRESO", key: "movimiento", type: "string" },
  { label: "No IDENTIFICACION", key: "identificacionTercero", type: "string" },
  { label: "NOMBRES Y APELLIDOS", key: "tesoreria", type: "string" },
  { label: "ENTIDAD PAGADORA", key: "nombreTercero", type: "string" },
  { label: "CONCEPTO", key: "nombreConcepto", type: "string" },
  //{ label: "Fecha", key: "fecha", type: "string" },
  //{ label: "Saldo Anterior", key: "saldoAnt", type: "money" },
  { label: "VALOR RECIBIDO EN EFECTIVO", key: "debito", type: "money" },
  { label: "Valor recibido x consignacion / transferencia", key: "", type: "money" },
  { label: "Vlr recibido x cheque", key: "", type: "string" },
  { label: "TIPO CREDITO", key: "", type: "string" },
  { label: "OBSERVACION", key: "", type: "string" },
  //{ label: "Crédito", key: "credito", type: "money" },
  //{ label: "Saldo", key: "saldo", type: "money" },
];*/

const MoveCaja = () => {
  const pageSize = 25;
  const context = useContext(InfoMovesContext);
  const environment = useContext(EnvironmentContext);
  const { loading, cajaMoves, handleCajaSubmit, handleLoading } = context;

  /* Pagination control */
  const [totalData, setTotalData] = useState();
  const [listDataPag, setListDataPag] = useState({});
  const [pagesLoaded, setPagesLoaded] = useState([1]);

  /* Fields */
  const [listTesorerias, setListTesorerias] = useState([]);
  const [tesoreriaSelected, setTesoreriaSelected] = useState();
  const [dateRange, setDateRange] = useState([new Date(new Date().setDate(new Date().getDate() - 8)), new Date()]);
  const [parsedDateRange, setParsedDateRange] = useState();
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (!environment) return;
    parseTesorerias();
  }, [environment])

  useEffect(() => {
    if (!dateRange || !handleDateRange) return;
    handleDateRange(dateRange);
  }, dateRange)

  const columns = [
    {
      dataField: 'movimiento',
      text: 'No. Movimiento',
      headerClasses: 'border-0',
      align: 'left',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      formatter: (dataField, selected) => (selected.debito ? "RC-" : "CE-") + dataField//refFormat(dataField),
    },
    {
      dataField: 'fecha',
      text: 'Fecha / Concepto',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      formatter: (dataField, selected) => dateConceptFormatter(dataField, selected),
      sort: true
    },
    /*{
      dataField: 'identificacionTercero',
      text: 'No. Identificación',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      //formatter: (dataField, selected) => clientFormatter(dataField, selected),
      sort: true
    },*/
    {
      dataField: 'nombreTercero',
      text: 'Nombres y Apellidos',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      formatter: (dataField, selected) => clientFormatter(dataField, selected),
      sort: true
    },
    {
      dataField: 'tesoreria',
      text: 'Entidad Pagadora',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      formatter: (dataField, selected) => selected.credito > 0 ? selected.pagaduria : dataField,
      sort: true
    },
    /*{
      dataField: 'nombreConcepto',
      text: 'Concepto',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      sort: true
    },*/
    {
      dataField: 'saldoAnt',
      text: 'Saldo Anterior',
      headerClasses: 'border-0 text-right',
      align: 'right',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      formatter: (value) => currencyFormat(value, '', '', 2),
    },
    {
      dataField: 'debito',
      text: 'Débito',
      headerClasses: 'border-0 text-right',
      align: 'right',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      formatter: (value) => currencyFormat(value, '', '', 2),
    },
    /*{
      dataField: '',
      text: 'Valor Recibido Consignación / Transferencia',
      headerClasses: 'border-0 text-right',
      align: 'right',
      classes: 'border-0 py-2 align-middle',
    },
    {
      dataField: '',
      text: 'Valor Recibido Cheque',
      headerClasses: 'border-0 text-right',
      align: 'right',
      classes: 'border-0 py-2 align-middle',
    },*/
    {
      dataField: 'credito',
      text: 'Crédito',
      headerClasses: 'border-0 text-right',
      align: 'right',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      formatter: (value) => currencyFormat(value, '', '', 2),
    },
    {
      dataField: 'saldo',
      text: 'Nuevo Saldo',
      headerClasses: 'border-0 text-right pr-3',
      align: 'right',
      classes: 'border-0 py-2 align-middle pr-3',
      sort: true,
      formatter: (value) => currencyFormat(value, '', '', 2),
    }
  ];

  const parseTesorerias = () => {
    if (!environment.treasuries) return;
    const tempListTesorerias = environment.treasuries.map(tesoreria => ({
      value: tesoreria.tesoreria,
      label: tesoreria.nombre
    }));

    setListTesorerias(tempListTesorerias);
  };

  const handleDateRange = (dates) => {
    if (!dates[0] || !dates[1]) return;
    const range = [];
    range[0] = dates[0] ? formatDate(dates[0]) : "";
    range[1] = dates[1] ? formatDate(dates[1]) : "";
    setParsedDateRange(range);
  }

  const onChangeTesoreria = data => {
    if (!environment || !environment.treasuries) return;
    if (!data || !data.value) {
      setTesoreriaSelected(null)
      return;
    }
    const tesoreriaIndex = environment.treasuries.findIndex(p => p.tesoreria == data.value);
    setTesoreriaSelected(environment.treasuries[tesoreriaIndex])
  }

  const onSubmit = async () => {
    setPagesLoaded([1]);
    if (/*!tesoreriaSelected ||*/ !parsedDateRange) {
      cogoToast.warn("Por favor completar los campos faltantes para la busqueda",
        { position: 'bottom-left', heading: 'Campos requeridos' });
      return;
    }
    const idTreasure = tesoreriaSelected?.tesoreria || 0;
    const startDate = parsedDateRange[0]
    const endDate = parsedDateRange[1]

    const response = await informesServices.getCajaMoves({ startDate, endDate, idTreasure, page: 1, size: pageSize });
    if (!response || response.error) {
      cogoToast.error(response?.msg || "No se logró completar la operación",
        { position: 'bottom-left', heading: 'Error al cargar los movimientos' });
      handleCajaSubmit([])
      return;
    }

    const { filas } = response.metadata || { filas: pageSize }
    setTotalData(filas);
    handleCajaSubmit(response.objResponse)
    const tempListDataPag = {};
    tempListDataPag['1'] = response.objResponse;
    setListDataPag(tempListDataPag);
  }

  const getExportData = (todo) => {
    if (!cajaMoves || !cajaMoves[0] /*|| !tesoreriaSelected*/) {
      cogoToast.warn("No existen datos a exportar",
        { position: 'bottom-left', heading: 'Sin Datos' });
      return;
    }

    if (todo == 1 && !cajaMoves.find(m => m.debito)) {
      cogoToast.warn("No existen ingresos a exportar",
        { position: 'bottom-left', heading: 'Sin Datos' });
      return;
    }

    if (todo == 2 && !cajaMoves.find(m => m.credito)) {
      cogoToast.warn("No existen egresos a exportar",
        { position: 'bottom-left', heading: 'Sin Datos' });
      return;
    }

    const idTreasure = tesoreriaSelected?.tesoreria || 0;
    const startDate = parsedDateRange[0];
    const endDate = parsedDateRange[1];
    const sesionToken = authSesion();
    window.open(`${urlApi}/recaudo/mov/caja/excel/${sesionToken}/${idTreasure}/${startDate}/${endDate}/${todo}`, "_blank");
  }

  const handlePagination = async page => {
    if (pagesLoaded.includes(page) || cajaMoves.length < pageSize) return;
    handleLoading(true);
    setPagesLoaded([...pagesLoaded, page]);

    const idTreasure = tesoreriaSelected?.tesoreria || 0;
    const startDate = parsedDateRange[0]
    const endDate = parsedDateRange[1]

    const response = await informesServices.getCajaMoves({ startDate, endDate, idTreasure, page, size: pageSize });
    if (!response || response.error) {
      cogoToast.error(response?.msg || "No se logró completar la operación",
        { position: 'bottom-left', heading: 'Error al cargar los movimientos' });
      handleCajaSubmit([])
      handleLoading(false);
      return;
    }

    const temp = [];
    const tempListDataPag = listDataPag;
    tempListDataPag[String(page)] = response.objResponse;

    const maxPageLoaded = [...pagesLoaded, page].sort((a, b) => b - a)[0];
    Array.from({ length: maxPageLoaded }, (_, i) => i + 1).map(p => {

      if (tempListDataPag[String(p)]) {
        temp.push(...tempListDataPag[String(p)])
      } else {
        temp.push(...Array.from({ length: pageSize }, (_, i) => ""))
      }
    })
    handleCajaSubmit(temp);
    setListDataPag(tempListDataPag);
    handleLoading(false);
  }

  return (
    <>
      <Card className={`my-3`} >
        <CardBody className="px-4">
          <Row>
            <Col lg={3} className="mx-2">
              <DetailRow title="Rango de Fechas">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selectsRange={true}
                  locale="es"
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  customInput={<ExampleCustomInput />}
                />
              </DetailRow>

            </Col>
            <Col lg={3} className="mx-2">
              <DetailRow title="Tesorería">
                <FormGroup>
                  <WizardInput
                    className="pl-2"
                    type="select"
                    tag={CustomInput}
                    value={tesoreriaSelected ? tesoreriaSelected.id : ''}
                    placeholder="Todas"
                    id="tesoreria"
                    name="tesoreria"
                    options={listTesorerias}
                    onChange={(e) => onChangeTesoreria({ name: 'tesoreria', value: e.target.value })}
                    errors={[]}
                  />
                </FormGroup>
              </DetailRow>
            </Col>
            <Col lg={1} className="mx-2">
              <DetailRow title="-" titleClass="text-white">
                <Button onClick={onSubmit} transform="shrink-3 down-2" color="primary" >
                  Buscar
                </Button>
              </DetailRow>
            </Col>
            <Col lg={4} className="mx-2">
              <DetailRow title="Exportar">
                <ButtonIcon onClick={() => getExportData(0)} transform="shrink-3 down-2" className="mr-2 mb-2" icon={faFileExcel}>
                  Informe
                </ButtonIcon>
              </DetailRow>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <MainTable
        title="Movimientos"
        data={cajaMoves}
        totalData={totalData}
        pageSize={pageSize}
        columns={columns}
        handlePagination={handlePagination}
        keyField="id"
        className="px-2"
        loading={loading}
        noSearch
        noAdd
        customPagination
      />
    </>
  )
}

export default MoveCaja